export enum GoogleLoginStatus {
	SKIPPED = 'skipped',
	LEGACY_DISPLAYED = 'legacy_displayed',
	LOGGED_IN = 'logged_in',
}
